module.exports = __webpack_public_path__ + "media/app/assets/races/undead_male-c9eb19c78321a533413833e39592c0db.png";